export default __webpack_public_path__ + "static/media/TranquilCourtImageSmall.ec44d17a.png";